import React from "react";
import {
  Box,
  Flex,
  Text,
  // useDisclosure,
} from "@chakra-ui/react";
import TableStatement from "./tableStatement";

export default function Statement() {
  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Báo cáo
          </Text>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }} >
        <TableStatement />
      </Box>
    </Box>
  );
}
